import { useEffect, useState } from "react";

export default function useMediaQuery(query: string): boolean | undefined {
  const [matches, setMatches] = useState<boolean | undefined>(undefined);

  const onMatchChange = (event: MediaQueryListEvent) => {
    setMatches(event.matches);
  }

  useEffect(() => {
    const media = window.matchMedia(query);
    setMatches(media.matches);
    
    media.addEventListener('change', onMatchChange, { passive: true });
    return () => {
      media.removeEventListener('change', onMatchChange);
    }
  }, [query]);

  return matches;
}